import {findIndex} from 'lodash';
import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'saving': false,
  'list': [],
  'partsList': [],
  'chassisList': [],
  'availableStock': [],
};

const updateTotalParts = (partsTotal, totalVehicles, part) => {
  const newTotal = [...partsTotal];
  const position = findIndex(newTotal, {'partCode': part.partCode});
  if (position === -1) {
    newTotal.push({
      'partCode': part.partCode,
      'partName': part.partName,
      'quantityByVehicle': part.quantityByVehicle,
      totalVehicles,
      'totalQuantity': part.quantityByVehicle * totalVehicles,
    });
    return newTotal;
  }

  const object = newTotal[position];
  const newObject = {...object};
  newObject.totalVehicles = object.totalVehicles + totalVehicles;
  newObject.totalQuantity =
    object.totalQuantity + part.quantityByVehicle * totalVehicles;

  return [
    ...newTotal.slice(0, position),
    newObject,
    ...newTotal.slice(position + 1),
  ];
};

const getPartsList = (list) => {
  let partsTotalList = [];

  list.forEach((item) => {
    const totalVehicles = item.totalVehicles;
    const partsList = item.partsList;

    partsList.forEach((part) => {
      partsTotalList = updateTotalParts(partsTotalList, totalVehicles, part);
    });
  });
  return partsTotalList;
};

export const setsOrders = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_SUMMARY_SETS_ORDERS]: (state, action) => ({
      ...state,
      'loading': true,
      'saving': false,
      'availableStock': [],
    }),
    [ActionTypes.FETCHED_SUMMARY_SETS_ORDERS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'partsList': getPartsList(action.response.data),
      'chassisList': action.response.chassisList,
    }),
    [ActionTypes.FETCHED_SUMMARY_SETS_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'partsList': [],
      'chassisList': [],
    }),
    [ActionTypes.FETCHING_STOCK]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_STOCK]: (state, action) => ({
      ...state,
      'loading': false,
      'availableStock': action.response.data,
    }),
    [ActionTypes.FETCHED_STOCK_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'availableStock': [],
    }),
    [ActionTypes.REQUESTING_ORDER_TO_CPD]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.REQUESTED_ORDER_TO_CPD]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.REQUESTED_ORDER_TO_CPD_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
  })(state, action);
};
